<template>
  <client-only>
    <v-dialog v-model="dialog" activator persistent>
      <template v-slot:activator="{ on }">
        <v-btn class="pointer-underline d-inline-flex px-2" text v-on="on">
          <span>{{ buttonText }}</span>
        </v-btn>
      </template>
      <v-card>
        <v-card-text class="display-18 pt-5 pb-0">
          <p>{{ issueToConfirm }}</p>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darkGray" text @click="confirmation = true" class="mx-2">{{ confirm }}</v-btn>
          <v-btn color="darkGray" text @click="dialog = false" class="mx-2">{{ abort }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </client-only>
</template>

<script>
export default {
  props: {
    buttonText: {
      type: String,
      default: ''
    },

    issueToConfirm: {
      type: String,
      default: ''
    },

    confirm: {
      type: String,
      default: ''
    },

    abort: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      confirmation: false,
      dialog: false
    }
  },

  watch: {
    confirmation() {
      if (this.confirmation) {
        this.$emit('confirmed')
        this.dialog = false
        this.confirmation = false
      }
    }
  }
}
</script>
